import { render } from "./ProjectImport.vue?vue&type=template&id=636b659a"
import script from "./ProjectImport.vue?vue&type=script&lang=js"
export * from "./ProjectImport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__